import { render, staticRenderFns } from "./PurchaseRequestShow.vue?vue&type=template&id=bfc633b2&scoped=true&"
import script from "./PurchaseRequestShow.vue?vue&type=script&lang=js&"
export * from "./PurchaseRequestShow.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseRequestShow.vue?vue&type=style&index=0&id=bfc633b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc633b2",
  null
  
)

export default component.exports